<ejs-grid #grid
          class="grid-with-toolbar"
          width='100%'
          rowHeight='38'
          [dataSource]="data"
          [allowFiltering]='true'
          [filterSettings]='filterOptions'
          [allowSorting]='true'
          [pageSettings]='pageSettings'
          [allowPaging]='true'
          [editSettings]="editSettings"
          [searchSettings]="searchOptions"
          [selectionSettings]="selectionOptions"
          (actionComplete)="actionComplete($event)"
          (actionBegin)="actionBegin($event)"
          (rowSelected)="rowSelectedChanged()"
          (rowDeselected)="rowSelectedChanged()"
          (rowDataBound)='rowDataBound($event)'
          (dataBound)="dataBound($event)">
  <ng-template #toolbarTemplate let-data>
    <ejs-toolbar>
      <e-items>
        <e-item [text]="'i18n.base.user-management.buttons.add-service-access' | translate" prefixIcon='e-icons icon-add' (click)="addUser()"></e-item>
      </e-items>
    </ejs-toolbar>
  </ng-template>
  <e-columns>
    <e-column type='checkbox' width='50'></e-column>
    <e-column headerText='id' field='userId' [visible]='false' [isPrimaryKey]='true'></e-column>
    <e-column headerText='roles' field='roles' [visible]='false'></e-column>
    <e-column [headerText]="'i18n.base.user-management.column-headers.client' | translate" field="client.name" clipMode='EllipsisWithTooltip' type="string"></e-column>
    <e-column [headerText]="'i18n.base.user-management.column-headers.userName' | translate" field="userName" clipMode='EllipsisWithTooltip' type="string"></e-column>
    <e-column [headerText]="'i18n.base.user-management.column-headers.email' | translate" field="email" clipMode='EllipsisWithTooltip' type="string"></e-column>
    <e-column headerText="" [commands]='gridCommands' width='120px'></e-column>
  </e-columns>
  <ng-template #editSettingsTemplate let-data>
    <app-user-edit-form [userEditForm]="gridEditForm"></app-user-edit-form>
  </ng-template>
</ejs-grid>
